<template>
  <div>
    <span v-if="data.column.field === 'status'">
      <div class="d-flex justify-content-between">
        <span>
          {{ data.row.status }}
        </span>
        <span>
          <b-button
            v-b-modal.modal-edit-property
            variant="link"
            class="p-0"
            @click="setPropertiesModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-button>
        </span>

      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const setPropertiesModel = propertiesModel => {
      const propModel = { ...propertiesModel }
      store.commit('SET_PROPERTIES_MODEL', propModel)
    }
    return {
      setPropertiesModel,
    }
  },
}
</script>
